import * as React from "react";
import { OfferButtonBuy } from "../shop/components/OfferButtonBuy";
import { LeagueRewardButtonWrapper } from "./LeagueRewardButtonWrapper";
export var LeagueRewardSpecialOfferButton = React.memo(function (_a) {
    var shopPackage = _a.shopPackage, _b = _a.disabled, disabled = _b === void 0 ? false : _b, onClick = _a.onClick, requiredLeague = _a.requiredLeague;
    return (React.createElement("div", { className: "flex flex--guts dialog-league-reward-special-offer__button-container" },
        React.createElement(LeagueRewardButtonWrapper, { disabled: disabled, requiredLeague: requiredLeague },
            React.createElement(OfferButtonBuy, { disabled: disabled, shopPackage: shopPackage, onClick: onClick }))));
});



//////////////////
// WEBPACK FOOTER
// ./src/features/tournament-building/LeagueRewardSpecialOfferButton.tsx
// module id = 2949
// module chunks = 3